
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { EmergencyExerciseListContainer } from "./exercise/EmergencyExerciseListContainer";
import { RoutineItemHeader } from "./routine-item/RoutineItemHeader";

interface RoutineItemProps {
  routine: {
    id: string;
    name: string;
    day: string;
    image_url?: string;
  };
  refetchRoutines: () => void;
}

export const RoutineItem = ({ routine, refetchRoutines }: RoutineItemProps) => {
  const handleDeleteRoutine = async () => {
    try {
      const { error } = await supabase
        .from("routines")
        .delete()
        .eq("id", routine.id);

      if (error) {
        console.error("Error deleting routine:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "No se pudo eliminar la rutina",
        });
        return;
      }

      toast({
        title: "Rutina eliminada",
        description: "La rutina ha sido eliminada exitosamente",
      });
      
      refetchRoutines();
    } catch (error) {
      console.error("Error in handleDeleteRoutine:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Ocurrió un error al eliminar la rutina",
      });
    }
  };

  return (
    <div className="bg-white/5 rounded-lg p-4">
      <RoutineItemHeader
        routine={routine}
        refetchRoutines={refetchRoutines}
        onDelete={handleDeleteRoutine}
      />
      {/* 🚨 EMERGENCY: Using simplified container */}
      <EmergencyExerciseListContainer routineId={routine.id} />
    </div>
  );
};
